// extracted by mini-css-extract-plugin
module.exports = {"wrapperFilter":"FilterPatient_wrapperFilter__28tBC","wrapperInput":"FilterPatient_wrapperInput__3xIJf","inputStyle":"FilterPatient_inputStyle__3XjH_"};